(function () {
  'use strict';

  if (window.FellinoraHeaderLoaded) {
    return;
  }

  window.FellinoraHeaderLoaded = true;

  function initHeader(header) {
    if (!header || header.dataset.fhInitialized === 'true') {
      return;
    }

    var drawer = header.querySelector('[data-fh-drawer]');
    var openButton = header.querySelector('[data-fh-drawer-open]');
    var closeButtons = header.querySelectorAll('[data-fh-drawer-close]');
    var dropdowns = header.querySelectorAll('.fh-dropdown');
    var mobileCollectionLinks = header.querySelectorAll('[data-fh-mobile-collection-link]');
    var scrollLockY = 0;
    var lastFocusedElement = null;
    var isDrawerOpen = false;

    function lockPageScroll() {
      scrollLockY = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollLockY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
      document.documentElement.style.overscrollBehavior = 'none';
    }

    function unlockPageScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
      document.documentElement.style.overscrollBehavior = '';
      window.scrollTo(0, scrollLockY);
    }

    function setDrawer(open) {
      if (!drawer || !openButton) {
        return;
      }

      if (open === isDrawerOpen) {
        return;
      }

      if (open) {
        lastFocusedElement = document.activeElement;
        lockPageScroll();
      } else {
        unlockPageScroll();
      }

      isDrawerOpen = open;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('fh-drawer-open', open);

      if (open) {
        window.requestAnimationFrame(function () {
          var closeButton = drawer.querySelector('[data-fh-drawer-close]');

          if (closeButton && typeof closeButton.focus === 'function') {
            closeButton.focus();
          }
        });
      } else if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
        lastFocusedElement = null;
      }
    }

    function onScroll() {
      header.classList.toggle('fh-is-scrolled', window.scrollY > 8);
      keepDropdownsInViewport();
    }

    function keepDropdownsInViewport() {
      var viewportPadding = 16;

      dropdowns.forEach(function (dropdown) {
        var width = dropdown.offsetWidth;
        var navItem = dropdown.closest('.fh-nav__item--dropdown');

        if (!navItem || width === 0) {
          return;
        }

        var navBounds = navItem.getBoundingClientRect();
        var left = navBounds.left + navBounds.width / 2 - width / 2;
        var maxLeft = window.innerWidth - viewportPadding - width;

        left = Math.min(Math.max(left, viewportPadding), Math.max(viewportPadding, maxLeft));

        dropdown.style.setProperty('--fh-dropdown-left', left + 'px');
        dropdown.style.setProperty('--fh-dropdown-top', (navBounds.bottom + 4) + 'px');
      });
    }

    if (openButton) {
      openButton.addEventListener('click', function () {
        setDrawer(true);
      });
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setDrawer(false);
      });
    });

    mobileCollectionLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isDrawerOpen) {
        event.preventDefault();
        setDrawer(false);
      }
    });

    header.classList.add('fh-dropdowns-ready');

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', keepDropdownsInViewport, { passive: true });

    dropdowns.forEach(function (dropdown) {
      var navItem = dropdown.closest('.fh-nav__item--dropdown');

      if (!navItem) {
        return;
      }

      navItem.addEventListener('mouseenter', keepDropdownsInViewport);
      navItem.addEventListener('focusin', keepDropdownsInViewport);
    });

    onScroll();
    keepDropdownsInViewport();

    header.dataset.fhInitialized = 'true';
  }

  function init(root) {
    (root || document).querySelectorAll('[data-fh-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
